export default (baseName) => `${baseName}.enabled`
